/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */
import { jsx } from '@emotion/react'

import { EuiPanel } from '@elastic/eui'

import BareBonesApp from './BareBonesApp'

import type { FunctionComponent } from 'react'

interface Props {
  children: React.ReactNode
}

const ApplicationLoadError: FunctionComponent<Props> = ({ children }) => (
  <BareBonesApp>
    <EuiPanel
      css={{
        margin: `2rem auto`,
        maxWidth: `40rem`,
      }}
    >
      {children}
    </EuiPanel>
  </BareBonesApp>
)

export default ApplicationLoadError
